<template>
  <van-overlay :show="show" @click="show = false" z-index="99999">
    <div class="wrapper" @click.stop>
      <div class="block"></div>
      <van-loading type="circular" size="40" color="#f4433a" />
    </div>
  </van-overlay>
</template>

<script>
import { Overlay, Loading } from "vant";

export default {
  props: ['showLoading'],
  components: {
    [Overlay.name]: Overlay,
    [Loading.name]: Loading
  },
  watch: {
    showLoading(val) {
      this.show = val;
    }
  },
  mounted() {
    this.show = this.showLoading
  },
  data() {
    return {
      show: false
    }
  }
}
</script>

<style>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  z-index: 9999999;
}
</style>
